<template>
  <Backdrop>
    <div class="fakeBackdrop" @click="cancelHandler"></div>

    <div class="fake-over"></div>

    <div class="container" ref="mainContainer">
      <div
        class="bar"
        ref="bar"
        draggable="true"
        @dragstart="dragStartHandler"
        @drag="modifyHeight"
        @dragend="endModifyHeight"
        @touchmove="modifyHeight"
        @touchend="endModifyHeight"
      ></div>

      <!-- Content -->
      <div
        class="content list"
        ref="listContainer"
        @scroll="loadMoreForInfiniteScroll"
      >
        <CommentList
          :post="post"
          :model="model"
          ref="list"
          @reply="replyHandler"
          @changeHeight="changeListHeightHandler"
        />
      </div>

      <!-- Input -->
      <div class="content input" ref="inputBox">
        <!-- <div> -->
        <CommentInput
          :post="post"
          ref="input"
          @sendMessage="sendMessage"
          @cancelReply="cancelReply"
        />
        <!-- </div> -->
      </div>
    </div>
  </Backdrop>
</template>

<script>
import Backdrop from "../Modal/Backdrop";
import CommentList from "./List.vue";
import CommentInput from "./Input.vue";

export default {
  components: { Backdrop, CommentList, CommentInput },
  props: {
    post: {
      type: Object,
      required: true,
    },
    model: {
      type: Object,
      required: true,
    },
  },
  methods: {
    dragStartHandler(e) {
      e.dataTransfer.setDragImage(new Image(), 0, 0);
    },
    replyHandler(data) {
      this.$refs.input.replyTo(data.comment);
      this.replyCallback = data.cb;
    },
    cancelReply() {
      this.replyCallback = null;
    },
    loadMoreForInfiniteScroll(e) {
      const element = e.target;

      if (element.scrollTop < this.lastScrollTop) return;

      this.lastScrollTop = element.scrollTop <= 0 ? 0 : element.scrollTop;

      if (element.scrollTop + element.offsetHeight >= element.scrollHeight) {
        this.$refs.list.endOfScrollReached();
      }
    },
    cancelHandler() {
      this.$refs.mainContainer.style.transition =
        "transform 0.2s ease-in-out, height 0.1s ease-in-out;";

      this.$refs.mainContainer.style.height = "0%";
      this.$refs.mainContainer.style.transform = `translateY(200px)`;

      this.containerAnimationTimeout = setTimeout(() => {
        this.$emit("cancel");
      }, 200);
    },
    modifyHeight(e) {
      this.cancelHeightTransition();

      let clientY = e.clientY;

      if (e.type !== "drag") {
        clientY = e.touches[0].clientY;
      } else if (e.x === 0 && e.y === 0) return;

      if (this.actualHeight !== null) {
        this.previousHeight = this.actualHeight;
      }

      this.actualHeight = this.maxHeight - clientY;
      this.$refs.mainContainer.style.height = `${this.actualHeight}px`;
    },
    changeListHeightHandler(value) {
      this.restoreHeightTransition();

      const barHeight = this.$refs.bar.clientHeight;
      const inputBoxHeight = this.$refs.inputBox.clientHeight;

      this.$refs.mainContainer.style.height = `${
        value + barHeight + inputBoxHeight + 10
      }px`;
    },
    restoreHeightTransition() {
      this.$refs.mainContainer.style.transition = "height 0.25s ease-in-out";
    },
    cancelHeightTransition() {
      this.$refs.mainContainer.style.transition = "";
    },
    endModifyHeight(e) {
      this.restoreHeightTransition();
      if (this.previousHeight > this.actualHeight) {
        this.cancelHandler();
      } else {
        this.$refs.mainContainer.style.height = "100%";
      }
    },
    sendMessage(data) {
      if (!this.replyCallback) {
        this.$refs.list.appendComment(data);
        // this.$refs.listContainer.scrollTop = 0;
        this.$refs.listContainer.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }

      this.replyCallback(data);
      this.replyCallback = null;
    },
  },
  data() {
    return {
      containerAnimationTimeout: null,
      actualHeight: null,
      previousHeight: null,
      maxHeight: window.innerHeight,
      lastScrollTop: 0,
      replyCallback: null,
    };
  },
  mounted() {
    this.$refs.mainContainer.style.transform = `translateY(0px)`;
  },
  beforeDestroy() {
    if (this.containerAnimationTimeout) {
      clearTimeout(this.containerAnimationTimeout);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";
@import "../../styles/classes";

$COLOR: var(--pallete_dark_color);

.fake-over {
  width: 100%;
  height: auto;

  background-color: transparent;

  display: flex;
  flex-grow: 1;
}

.container {
  width: 100%;
  height: 300px;
  max-height: 100%;
  margin-top: auto;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: end;

  position: relative;
  z-index: 99;

  transform: translateY(100%);

  transition: transform 0.25s ease-in-out;

  > .bar {
    width: 100%;
    height: 3em;
    background-color: $COLOR;

    border-radius: 10px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.25);

    // border-bottom: 1px solid rgba(var(--pallete_dark_text_color), 0.25);

    cursor: grab;

    &::after {
      position: relative;
      display: flex;
      content: "";
      width: 5%;
      height: 5px;
      margin-block: 0.75em 1.25em;
      margin-inline: auto;
      left: 0;
      right: 0;

      background-color: var(--pallete_dark_text_color);

      border-radius: 5px;

      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.25);
    }
  }

  > .content {
    width: 100%;
    background-color: $COLOR;
    display: flex;
    padding-top: 1em;

    // flex-grow: 1;
    overflow: scroll;

    &::-webkit-scrollbar {
      display: none;
    }

    &.list {
      flex-grow: 1;
      padding-bottom: 7em;
    }

    &.input {
      width: 100%;
      padding: 0;
      padding-block: 0 0.5em;

      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 999;
    }
  }
}

.fakeBackdrop {
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  position: absolute;
  z-index: 0;
}
</style>
